import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
  Container, Box, Typography, Paper, Grid, TextField, Button,
  Switch, FormControlLabel, Divider, Alert, Card,
  CardContent, Chip, IconButton, Dialog, DialogTitle, DialogContent,
  DialogActions, Table, TableBody, TableCell, TableContainer, TableHead,
  TableRow, Select, MenuItem, FormControl, InputLabel, CircularProgress,
  useMediaQuery, useTheme, Tabs, Tab, Stack, Accordion, AccordionSummary, AccordionDetails
} from '@mui/material';
import {
  Settings, Save, Receipt, CheckCircle, Error as ErrorIcon,
  CloudUpload, ContentCopy, Download, PlayArrow, Sync, ExpandMore,
  Email as EmailIcon, Tune as TuneIcon, ReceiptLong, Print, Build
} from '@mui/icons-material';
import TituloPagina from './utils/TituloPagina.jsx';
import { MenuInicial } from "./MenuInicial";
import HistorialPagos from './HistorialPagos';
import Cargando from './utils/Cargando.jsx';
import {
  API_BASE_URL, FACTURACION_GET, FACTURACION_SAVE, FACTURACION_TEST, FACTURACION_PROXNUM, FACTURACION_CERT_GUARDAR,
  IMPRESION_SUCURSALES, IMPRESION_SUCURSAL_GUARDAR, IMPRESION_CERTIFICADO, SUCURSALES_LISTAR, PRODUCTOS_LISTAR,
} from '../services/apiConfig';
import { buscarImpresoras, construirTicketPreviewTexto, ventaDePrueba } from '../services/impresora';
import { avisar } from '../services/toast';

const TIPOS_COMPROBANTE = [
  { id: 1, nombre: 'Factura A' },
  { id: 2, nombre: 'Nota de Débito A' },
  { id: 3, nombre: 'Nota de Crédito A' },
  { id: 6, nombre: 'Factura B' },
  { id: 7, nombre: 'Nota de Débito B' },
  { id: 8, nombre: 'Nota de Crédito B' },
  { id: 11, nombre: 'Factura C' },
  { id: 12, nombre: 'Nota de Débito C' },
  { id: 13, nombre: 'Nota de Crédito C' },
  { id: 15, nombre: 'Factura E' },
];

const CONDICIONES_IVA = [
  { id: '1', nombre: 'Responsable Inscripto' },
  { id: '2', nombre: 'Responsable no Inscripto' },
  { id: '3', nombre: 'Responsable no Inscripto - Born' },
  { id: '4', nombre: 'Exento' },
  { id: '5', nombre: 'Consumidor Final' },
  { id: '6', nombre: 'Remitente' },
  { id: '9', nombre: 'Monotributista' },
];

function TabPanel({ children, value, index }) {
  return (
    <div role="tabpanel" hidden={value !== index}>
      {value === index && <Box sx={{ pt: 2 }}>{children}</Box>}
    </div>
  );
}

function FacturacionConfig() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const userData = JSON.parse(sessionStorage.getItem("userData"));
  const perfil = userData?.perfil;

  const getAuthHeaders = () => {
    const token = sessionStorage.getItem('authToken');
    return token ? { Authorization: `Bearer ${token}` } : {};
  };

  const [tabValue, setTabValue] = useState(0);
  const [loading, setLoading] = useState(true);
  const [guardando, setGuardando] = useState(false);
  const [probando, setProbando] = useState(false);
  const [obteniendoProxNum, setObteniendoProxNum] = useState(false);
  const [certDialogOpen, setCertDialogOpen] = useState(false);
  const [generandoCert, setGenerandoCert] = useState(false);
  const [certForm, setCertForm] = useState({ cert: '', cert_key: '' });
  const [testDialogOpen, setTestDialogOpen] = useState(false);
  const [testResult, setTestResult] = useState(null);
  const [confirmMantenimientoOpen, setConfirmMantenimientoOpen] = useState(false);
  const [guardandoMantenimiento, setGuardandoMantenimiento] = useState(false);
  const [sucursales, setSucursales] = useState([]);
  const [sucursalPrueba, setSucursalPrueba] = useState('');
  const [productosCatalogo, setProductosCatalogo] = useState([]);

  const [config, setConfig] = useState({
    habilitado: false,
    mantenimiento: false,
    tiene_certificado: false,
    punto_venta: 1,
    tipo_comprobante_predeterminado: 6,
    razon_social: '',
    cuit: '',
    domicilio: '',
    condicion_iva: '5',
    condiciones_iva_por_defecto: '5',
    ambiente: 'dev',
    mostrar_preview: true,
    auto_imprimir: false,
    smtp_host: '',
    smtp_port: 587,
    smtp_encryption: 'tls',
    smtp_user: '',
    smtp_pass: '',
    smtp_from_email: '',
    smtp_from_name: '',
    iva_porcentaje: 21.00,
    sesion_minutos: 60,
    nombre_sistema: 'Sistema de Gestión',
    version_manual: '',
    color_primario: '#071c44',
    max_imagenes_producto: 5,
    max_imagenes_total: 100,
    fecha_vencimiento: '',
    pago_mensual_monto: 0.00,
    producto_referencia_club_grido: '',
    producto_referencia_multiplicador: 2,
    monto_por_sucursal: 0.00,
    monto_total: 0.00,
    fuente_precio_licencia: 'manual',
    producto_referencia_descripcion: null,
    producto_referencia_precio_base: null,
    producto_referencia_multiplicador_efectivo: 2,
    email_notificacion_pagos: '',
    impresion_texto_pie: '',
    impresion_qz_cert: '',
  });

  const [stats, setStats] = useState({ total_imagenes: 0 });
  const [licencia, setLicencia] = useState({ dias_restantes: null, expirado: false });

  // ---- Comandera (impresión de ticket por sucursal) ----
  const [sucursalesImpresion, setSucursalesImpresion] = useState([]);
  const [cargandoSucursales, setCargandoSucursales] = useState(false);
  const [impresorasPorSucursal, setImpresorasPorSucursal] = useState({});
  const [buscandoId, setBuscandoId] = useState(null);
  const [guardandoId, setGuardandoId] = useState(null);
  const [generandoCertImpresion, setGenerandoCertImpresion] = useState(false);
  const [previewSucursal, setPreviewSucursal] = useState(null);

  useEffect(() => {
    if (perfil !== 1) {
      avisar('Solo administradores pueden acceder', 'error');
      return;
    }
    fetchConfig();
    axios.get(API_BASE_URL + SUCURSALES_LISTAR, { headers: getAuthHeaders() })
      .then((res) => setSucursales(res.data?.data ?? []))
      .catch(() => setSucursales([]));
    // Catálogo de productos, para elegir "producto de referencia" del
    // precio de licencia (ej. Kilo de Helado) — solo los activos se ofrecen.
    axios.get(API_BASE_URL + PRODUCTOS_LISTAR, { headers: getAuthHeaders() })
      .then((res) => setProductosCatalogo(res.data?.data ?? []))
      .catch(() => setProductosCatalogo([]));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchConfig = async () => {
    try {
      setLoading(true);
      const response = await axios.get(API_BASE_URL + FACTURACION_GET, {
        headers: getAuthHeaders()
      });
      const payload = response.data?.data ?? response.data;
      if (response.data.success && response.data.data) {
        setConfig(prev => ({ ...prev, ...response.data.data }));
      }
      const statsData = response.data?.stats ?? payload?.stats;
      if (statsData) {
        setStats(statsData);
      }
      const licenciaData = response.data?.licencia ?? payload?.licencia;
      if (licenciaData) {
        setLicencia(licenciaData);
      }
    } catch (error) {
      console.error('Error al cargar configuración:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (tabValue !== 3 || sucursalesImpresion.length > 0 || cargandoSucursales) return;
    setCargandoSucursales(true);
    axios.get(API_BASE_URL + IMPRESION_SUCURSALES, { headers: getAuthHeaders() })
      .then((res) => setSucursalesImpresion(res.data?.data ?? []))
      .catch(() => setSucursalesImpresion([]))
      .finally(() => setCargandoSucursales(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tabValue]);

  const actualizarSucursalImpresion = (idx, campo, valor) => {
    setSucursalesImpresion((prev) => prev.map((s, i) => (i === idx ? { ...s, [campo]: valor } : s)));
  };

  const guardarSucursalImpresion = async (s) => {
    setGuardandoId(s.id);
    try {
      const response = await axios.post(API_BASE_URL + IMPRESION_SUCURSAL_GUARDAR, {
        sucursal_id: s.id,
        impresion_habilitada: s.impresion_habilitada ? 1 : 0,
        impresion_marca: s.impresion_marca,
        impresion_nombre_impresora: s.impresion_nombre_impresora,
        impresion_ancho_papel: s.impresion_ancho_papel,
        impresion_cortar_papel: s.impresion_cortar_papel ? 1 : 0,
        impresion_nombre_fantasia: s.impresion_nombre_fantasia || '',
        impresion_texto_pie: s.impresion_texto_pie || '',
      }, { headers: getAuthHeaders() });
      avisar(response.data.message || `Impresora de ${s.nombre} guardada`, response.data.success ? 'success' : 'error');
    } catch (error) {
      avisar('Error al guardar la configuración de impresión', 'error');
    } finally {
      setGuardandoId(null);
    }
  };

  const buscarImpresorasPara = async (sucursalId) => {
    setBuscandoId(sucursalId);
    try {
      const lista = await buscarImpresoras(config.impresion_qz_cert);
      const arr = Array.isArray(lista) ? lista : (lista ? [lista] : []);
      setImpresorasPorSucursal((prev) => ({ ...prev, [sucursalId]: arr }));
      avisar(`${arr.length} impresora(s) encontrada(s)`, arr.length ? 'success' : 'warning');
    } catch (error) {
      avisar('QZ Tray no detectado en esta PC. ¿Está instalado y corriendo?', 'error');
    } finally {
      setBuscandoId(null);
    }
  };

  // Descarga el certificado ya generado como archivo -- así en la PC de caja
  // solo hay que moverlo a la carpeta de QZ Tray, sin copiar/pegar a mano en
  // el Bloc de notas (que además puede agregar un .txt sin querer).
  const descargarCertificadoImpresion = () => {
    const blob = new Blob([config.impresion_qz_cert], { type: 'application/x-x509-ca-cert' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'override.crt';
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  };

  const generarCertificadoImpresion = async () => {
    setGenerandoCertImpresion(true);
    try {
      const response = await axios.post(API_BASE_URL + IMPRESION_CERTIFICADO, {}, { headers: getAuthHeaders() });
      if (response.data.success) {
        setConfig((prev) => ({ ...prev, impresion_qz_cert: response.data.data.certificate }));
        avisar('Certificado generado correctamente', 'success');
      } else {
        avisar(response.data.message || 'Error al generar certificado', 'error');
      }
    } catch (error) {
      avisar('Error al generar certificado', 'error');
    } finally {
      setGenerandoCertImpresion(false);
    }
  };

  // Guardado aparte del resto del form: activar/desactivar mantenimiento
  // tiene que aplicar YA, sin depender de que el admin además clickee el
  // botón "Guardar" general (que de paso mandaría cualquier otro cambio a
  // medio hacer en la pantalla).
  const guardarMantenimiento = async (activar) => {
    setGuardandoMantenimiento(true);
    try {
      const response = await axios.post(API_BASE_URL + FACTURACION_SAVE, {
        mantenimiento: activar ? 1 : 0,
      }, { headers: getAuthHeaders() });
      if (response.data.success) {
        setConfig((prev) => ({ ...prev, mantenimiento: activar }));
        avisar(activar ? 'Modo mantenimiento activado: se desloguearon todos los usuarios' : 'Modo mantenimiento desactivado', 'success');
      } else {
        avisar(response.data.message || 'Error al guardar', 'error');
      }
    } catch (error) {
      avisar('Error al guardar el modo mantenimiento', 'error');
    } finally {
      setGuardandoMantenimiento(false);
      setConfirmMantenimientoOpen(false);
    }
  };

  const guardarConfig = async () => {
    try {
      setGuardando(true);
      const response = await axios.post(API_BASE_URL + FACTURACION_SAVE, {
        ...config,
        habilitado: config.habilitado ? 1 : 0,
        mostrar_preview: config.mostrar_preview ? 1 : 0,
        auto_imprimir: config.auto_imprimir ? 1 : 0,
      }, {
        headers: getAuthHeaders()
      });

      if (response.data.success) {
        avisar('Configuración guardada exitosamente', 'success');
        localStorage.setItem('color_sistema', config.color_primario || '#071c44');
        localStorage.setItem('color_icono', config.color_icono || '#a9b9a6');
        localStorage.setItem('nombre_sistema', config.nombre_sistema || 'Sistema de Gestión');
        document.documentElement.style.setProperty('--color-sistema', config.color_primario || '#071c44');
        document.title = config.nombre_sistema || 'Sistema de Gestión';
      } else {
        avisar(response.data.message || 'Error al guardar', 'error');
      }
    } catch (error) {
      avisar('Error de conexión', 'error');
    } finally {
      setGuardando(false);
    }
  };

  const handleChange = (campo, valor) => {
    setConfig({ ...config, [campo]: valor });
  };

  const probarConexion = async () => {
    if (!config.tiene_certificado) {
      avisar('Primero cargá el certificado AFIP', 'warning');
      return;
    }

    try {
      setProbando(true);
      setTestResult(null);
      setTestDialogOpen(true);

      const response = await axios.post(API_BASE_URL + FACTURACION_TEST, {
        sucursal_id: sucursalPrueba || undefined
      }, {
        headers: getAuthHeaders()
      });

      if (response.data.success) {
        setTestResult({
          success: true,
          message: response.data.message,
          data: response.data.data
        });
      } else {
        setTestResult({
          success: false,
          message: response.data.message,
          data: null
        });
      }
    } catch (error) {
      setTestResult({
        success: false,
        message: 'Error de conexión: ' + (error.response?.data?.message || error.message),
        data: null
      });
    } finally {
      setProbando(false);
    }
  };

  const obtenerProximoNumero = async () => {
    if (!config.tiene_certificado) {
      avisar('Primero cargá el certificado AFIP', 'warning');
      return;
    }
    try {
      setObteniendoProxNum(true);
      const response = await axios.post(API_BASE_URL + FACTURACION_PROXNUM, {
        sucursal_id: sucursalPrueba || undefined,
        tipo_comprobante: config.tipo_comprobante_predeterminado
      }, {
        headers: getAuthHeaders()
      });
      if (response.data.success) {
        avisar(`Próximo número: ${response.data.data.proximo_numero} (último: ${response.data.data.ultimo_numero})`, 'success');
      } else {
        avisar(response.data.message || 'Error al obtener próximo número', 'error');
      }
    } catch (error) {
      avisar('Error de conexión: ' + (error.response?.data?.message || error.message), 'error');
    } finally {
      setObteniendoProxNum(false);
    }
  };

  const guardarCertificado = async () => {
    if (!certForm.cert || !certForm.cert_key) {
      avisar('Pegá el certificado y la clave privada', 'warning');
      return;
    }
    try {
      setGenerandoCert(true);
      const response = await axios.post(API_BASE_URL + FACTURACION_CERT_GUARDAR, certForm, {
        headers: getAuthHeaders(),
      });
      if (response.data.success) {
        const d = response.data.data || {};
        avisar(
          d.vencido
            ? `Certificado guardado, pero venció el ${d.vencimiento} — cargá uno nuevo antes de facturar.`
            : `Certificado guardado (${d.alias || 'sin alias'}${d.vencimiento ? `, vence ${d.vencimiento}` : ''})`,
          d.vencido ? 'warning' : 'success'
        );
        setConfig((prev) => ({ ...prev, tiene_certificado: true }));
        setCertDialogOpen(false);
        setCertForm({ cert: '', cert_key: '' });
      } else {
        avisar(response.data.message || 'Error al guardar el certificado', 'error');
      }
    } catch (error) {
      avisar('Error: ' + (error.response?.data?.message || error.message), 'error');
    } finally {
      setGenerandoCert(false);
    }
  };

  if (loading) {
    return (
      <Container maxWidth={isMobile ? false : "xl"} sx={{ px: isMobile ? 1 : 3 }}>
        <MenuInicial />
        <Cargando inline />
      </Container>
    );
  }

  return (
    <Container maxWidth={isMobile ? false : "xl"} sx={{ px: isMobile ? 1 : 3 }}>
      <style>{`.spin { animation: spin 1s linear infinite; } @keyframes spin { 100% { transform: rotate(360deg); } }`}</style>
      <MenuInicial />

      <Box sx={{ my: 3 }}>
        <Paper sx={{ p: isMobile ? 1.5 : 3 }}>
          <TituloPagina
            icon={ReceiptLong}
            titulo="Facturación"
            subtitulo="Administrá la configuración global del sistema"
            ayuda="Configurá la conexión con ARCA y los datos fiscales"
          />

          <Divider sx={{ mb: 2 }} />

          {/* Fuera de las tabs, siempre visible: es la única acción de esta
              pantalla que afecta a todos los usuarios en cualquier momento
              (no solo cuando se toca "Guardar"), así que amerita estar
              siempre a la vista y aparte del resto de la configuración. */}
          <Alert
            severity={config.mantenimiento ? 'error' : 'warning'}
            variant="outlined"
            icon={<Build />}
            sx={{ mb: 2 }}
            action={
              <FormControlLabel
                sx={{ mr: 0 }}
                control={
                  <Switch
                    checked={config.mantenimiento}
                    disabled={guardandoMantenimiento}
                    color="error"
                    onChange={(e) => {
                      if (e.target.checked) {
                        setConfirmMantenimientoOpen(true);
                      } else {
                        guardarMantenimiento(false);
                      }
                    }}
                  />
                }
                label={config.mantenimiento ? 'Activado' : 'Desactivado'}
              />
            }
          >
            <strong>Modo mantenimiento.</strong> Al activarlo, todos los usuarios (menos administradores) quedan desconectados
            en el momento y no pueden volver a entrar hasta que lo desactives — se les muestra "Estamos realizando mejoras,
            por favor intente de nuevo en unos minutos.". Usalo mientras hacés un deploy.
          </Alert>

          <Dialog open={confirmMantenimientoOpen} onClose={() => setConfirmMantenimientoOpen(false)}>
            <DialogTitle>¿Activar modo mantenimiento?</DialogTitle>
            <DialogContent>
              <Typography>
                Todos los usuarios que no sean administradores van a quedar desconectados ahora mismo
                y no van a poder volver a entrar hasta que lo desactives.
              </Typography>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setConfirmMantenimientoOpen(false)} disabled={guardandoMantenimiento}>Cancelar</Button>
              <Button
                onClick={() => guardarMantenimiento(true)}
                color="error"
                variant="contained"
                disabled={guardandoMantenimiento}
                startIcon={guardandoMantenimiento ? <CircularProgress size={16} color="inherit" /> : null}
              >
                Activar
              </Button>
            </DialogActions>
          </Dialog>

          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs
              value={tabValue}
              onChange={(e, v) => setTabValue(v)}
              variant="scrollable"
              scrollButtons={isMobile ? 'auto' : false}
              allowScrollButtonsMobile
              sx={{
                minHeight: isMobile ? 64 : undefined,
                '& .MuiTab-root': {
                  minWidth: isMobile ? 76 : 120,
                  minHeight: isMobile ? 64 : undefined,
                  fontSize: isMobile ? '0.7rem' : undefined,
                  px: isMobile ? 0.75 : undefined,
                  gap: isMobile ? 0.25 : undefined,
                },
                '& .MuiTabs-indicator': { height: 3 },
              }}
            >
              <Tab value={2} icon={<TuneIcon fontSize={isMobile ? 'small' : 'medium'} />} label="General" iconPosition={isMobile ? 'top' : 'start'} />
              <Tab value={1} icon={<EmailIcon fontSize={isMobile ? 'small' : 'medium'} />} label="Correo" iconPosition={isMobile ? 'top' : 'start'} />
              <Tab value={3} icon={<Print fontSize={isMobile ? 'small' : 'medium'} />} label="Comandera" iconPosition={isMobile ? 'top' : 'start'} />
              <Tab value={0} icon={<Receipt fontSize={isMobile ? 'small' : 'medium'} />} label="Facturación" iconPosition={isMobile ? 'top' : 'start'} />
            </Tabs>
          </Box>

          {/* ===== TAB FACTURACIÓN ===== */}
          <TabPanel value={tabValue} index={0}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <Card sx={{ height: '100%' }}>
                  <CardContent>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                      <Typography variant="h6">
                        <CheckCircle sx={{ mr: 1, verticalAlign: 'middle' }} />
                        Estado del Servicio
                      </Typography>
                      <Chip
                        icon={config.habilitado ? <CheckCircle /> : <ErrorIcon />}
                        label={config.habilitado ? 'Habilitado' : 'Deshabilitado'}
                        color={config.habilitado ? 'success' : 'default'}
                      />
                    </Box>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={config.habilitado}
                          onChange={(e) => handleChange('habilitado', e.target.checked)}
                          color="primary"
                        />
                      }
                      label="Habilitar facturación electrónica"
                    />
                  </CardContent>
                </Card>
              </Grid>

              <Grid item xs={12} md={6}>
                <Card sx={{ height: '100%' }}>
                  <CardContent>
                    <Typography variant="h6" gutterBottom>
                      Entorno
                    </Typography>
                    <FormControl fullWidth size="small">
                      <InputLabel>Ambiente</InputLabel>
                      <Select
                        value={config.ambiente}
                        label="Ambiente"
                        onChange={(e) => handleChange('ambiente', e.target.value)}
                      >
                        <MenuItem value="dev">Desarrollo (Testing)</MenuItem>
                        <MenuItem value="prod">Producción</MenuItem>
                      </Select>
                    </FormControl>
                    <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
                      En desarrollo puedes usar el CUIT de prueba sin certificado.
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>

              <Grid item xs={12}>
                <Accordion sx={{ bgcolor: 'grey.50' }}>
                  <AccordionSummary expandIcon={<ExpandMore />}>
                    <Typography variant="h6">Pasos para habilitar AFIP (sin SDK pago)</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                      Guía completa para generar tu propio certificado y hablar directo con los web services de AFIP (WSAA + WSFEv1) — sin pasar por app.afipsdk.com ni ningún intermediario pago. Pensada para facturar como <strong>Consumidor Final</strong> (Factura B si sos Responsable Inscripto, Factura C si sos Monotributista).
                    </Typography>

                    <Alert severity="warning" sx={{ mb: 2 }}>
                      Hacelo primero en <strong>Homologación</strong> (ambiente de pruebas de AFIP, gratis e ilimitado) y recién cuando funcione ahí repetís los mismos pasos en <strong>Producción</strong>. Son <strong>certificados distintos</strong>, <strong>altas de servicio distintas</strong> y hasta <strong>URLs distintas</strong> — no se mezclan entre sí. Un comprobante emitido en Homologación no existe para AFIP real y no cuenta como facturado.
                    </Alert>

                    <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 0.5 }}>0. Requisitos previos</Typography>
                    <Box component="ul" sx={{ m: 0, mb: 2, pl: 2.5 }}>
                      <Typography component="li" variant="body2">Clave Fiscal <strong>nivel 3</strong> (si tenés nivel 2, subila desde la web de AFIP con token de seguridad o yendo a una dependencia).</Typography>
                      <Typography component="li" variant="body2">CUIT dado de alta en el régimen que corresponda (Monotributo o Responsable Inscripto).</Typography>
                    </Box>

                    <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 0.5 }}>1. Generar el certificado (CSR + clave privada)</Typography>
                    <Typography variant="body2" sx={{ mb: 0.5 }}>
                      Se hace UNA vez por ambiente (una para Homologación, otra para Producción — son trámites separados, no se reusa el mismo). La clave privada <strong>nunca sale de tu máquina</strong> — solo subís el CSR, que no la contiene. En Windows, <code>openssl</code> no está instalado como comando global: usá la ruta completa al que ya viene con XAMPP (funciona igual en PowerShell o en CMD):
                    </Typography>
                    <Box component="pre" sx={{ fontFamily: 'monospace', fontSize: 12, bgcolor: 'grey.200', p: 1, borderRadius: 1, mb: 2, overflowX: 'auto' }}>
{`"C:\\xampp\\apache\\bin\\openssl.exe" genrsa -out privada.key 2048
"C:\\xampp\\apache\\bin\\openssl.exe" req -new -key privada.key -config "C:\\xampp\\apache\\conf\\openssl.cnf" -subj "/C=AR/O=TuRazonSocial/CN=agilia-homologacion/serialNumber=CUIT 20XXXXXXXXX" -out pedido.csr`}
                    </Box>
                    <Typography variant="body2" sx={{ mb: 2 }}>
                      El <code>-config</code> es necesario: el <code>openssl.exe</code> de XAMPP viene compilado con una ruta por defecto que no existe en Windows (<code>C:\Apache24\conf\openssl.cnf</code>), y sin <code>-config</code> explícito el comando <code>req</code> falla con "Can't open ...openssl.cnf" aunque <code>genrsa</code> funcione bien. El segundo comando además pide algunos datos extra por consola (país/provincia/etc.) — podés dejarlos en blanco con Enter, lo único que importa es el <code>-subj</code> que ya va completo. Los archivos <code>privada.key</code> y <code>pedido.csr</code> quedan en la carpeta donde corriste el comando. Para Producción repetís esto cambiando el <code>CN=</code> (ej. <code>agilia-produccion</code>).
                    </Typography>

                    <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 0.5 }}>2. Homologación: alta y autorización (portal WSASS de testing)</Typography>
                    <Typography variant="body2" sx={{ mb: 0.5 }}>
                      Homologación tiene su <strong>propio portal autoservicio</strong>, separado del "Administrador de Relaciones" de Producción — no hace falta Computador Fiscal ni delegación:
                    </Typography>
                    <Box component="ol" sx={{ m: 0, mb: 1, pl: 2.5 }}>
                      <Typography component="li" variant="body2">Entrá a <a href="https://wsass-homo.afip.gob.ar/wsass/portal/main.aspx" target="_blank" rel="noopener noreferrer">wsass-homo.afip.gob.ar</a> con tu Clave Fiscal (nivel 3).</Typography>
                      <Typography component="li" variant="body2">Menú izquierdo → <strong>"Crear DN y certificado"</strong>: nombre simbólico del DN (<strong>solo letras y números, sin guiones ni guiones bajos</strong>), el CUIT ya viene precargado, y pegás el contenido completo de <code>pedido.csr</code>. Copiá el certificado resultante entero (con <code>Ctrl+A</code> adentro del cuadro, no arrastrando con el mouse — es chico y con scroll).</Typography>
                      <Typography component="li" variant="body2">Menú izquierdo → <strong>"Crear autorización a servicio"</strong>: elegís el DN recién creado y el servicio <code>wsfe - Facturacion Electronica</code>, confirmás.</Typography>
                    </Box>
                    <Alert severity="info" sx={{ mb: 2 }}>
                      El paso de autorización es el que faltaba si ves el error <code>600: ValidacionDeToken: No aparecio CUIT en lista de relaciones</code> — son dos validaciones independientes: WSAA solo valida que el certificado sea de confianza, WSFEv1 además valida esta autorización, aunque el login a WSAA ya haya funcionado.
                    </Alert>

                    <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 0.5 }}>3. Producción: alta vía Administrador de Relaciones (más largo)</Typography>
                    <Typography variant="body2" sx={{ mb: 0.5 }}>
                      Producción no tiene el autoservicio de arriba — necesita un <strong>Computador Fiscal</strong> registrado:
                    </Typography>
                    <Box component="ol" sx={{ m: 0, mb: 1, pl: 2.5 }}>
                      <Typography component="li" variant="body2">Entrá a <a href="https://www.afip.gob.ar" target="_blank" rel="noopener noreferrer">afip.gob.ar</a> con tu Clave Fiscal → <strong>"Administrador de Relaciones de Clave Fiscal"</strong>.</Typography>
                      <Typography component="li" variant="body2">Adherí <strong>"Administración de Certificados Digitales"</strong> (versión Producción) → <strong>"Agregar alias"</strong> → subís el <code>pedido.csr</code> de Producción → AFIP devuelve el <code>.crt</code>. Esto registra el certificado como Computador Fiscal.</Typography>
                      <Typography component="li" variant="body2">De nuevo en "Administrador de Relaciones" → <strong>"Nueva Relación"</strong> → buscá <strong>"WSFE - Facturación Electrónica"</strong> → como Representante elegí el Computador Fiscal recién creado → confirmá.</Typography>
                    </Box>
                    <Alert severity="warning" sx={{ mb: 2 }}>
                      Si AFIP dice "Ud no cuenta con Computadores Fiscales registrados" al llegar al paso 3, es que el paso 2 no se completó (o se hizo con otro certificado) — volvé ahí antes de seguir. Si sos Monotributista y nunca facturaste online, además puede que tengas que habilitar el punto de venta desde "Comprobantes en línea" → "Puntos de Venta" → Nuevo (tipo "Facturador Electrónico - Webservices").
                    </Alert>

                    <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 0.5 }}>4. Qué cargar acá abajo</Typography>
                    <Box component="ul" sx={{ m: 0, mb: 2, pl: 2.5 }}>
                      <Typography component="li" variant="body2"><strong>CUIT</strong>: sin guiones.</Typography>
                      <Typography component="li" variant="body2">
                        <strong>Punto de Venta</strong>: el número habilitado para Web Services (paso 3). Acá abajo cargás el <strong>general</strong> — si tenés más de una sucursal, cada una puede tener el suyo propio (Sucursales &gt; editar), dado de alta por separado en AFIP con el mismo paso 2/3 pero un número distinto por sucursal. No es obligatorio: una sucursal sin PV propio usa el general. Sí es <strong>recomendado</strong> apenas hay 2+ sucursales activas — AFIP numera los comprobantes por Punto de Venta, así que compartir uno entre sucursales que venden al mismo tiempo puede pisar la numeración (en "Sucursales" te avisa con un chip ámbar si a alguna le falta).
                      </Typography>
                      <Typography component="li" variant="body2"><strong>Condición ante IVA</strong>: define si el comprobante para consumidor final sale tipo B o tipo C.</Typography>
                      <Typography component="li" variant="body2"><strong>Certificado AFIP</strong>: el contenido del <code>.crt</code> y de <code>privada.key</code>, tal cual quedaron los archivos (texto plano, sin convertir nada) — en la card de abajo. Copiá el archivo <strong>completo</strong> (desde <code>-----BEGIN...</code> hasta <code>-----END...-----</code>): si pegás solo una parte, o queda mezclado con un intento anterior a medio borrar, el guardado falla con "El certificado no es un PEM válido" — borrá el campo entero (<code>Ctrl+A</code>, <code>Delete</code>) y pegá de nuevo si eso pasa.</Typography>
                      <Typography component="li" variant="body2"><strong>Ambiente</strong>: "Desarrollo (Testing)" mientras probás, "Producción" recién cuando ya facturaste de prueba sin errores en Homologación.</Typography>
                    </Box>

                    <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 0.5 }}>5. Probar antes de facturar en serio</Typography>
                    <Typography variant="body2" sx={{ mb: 2 }}>
                      Con el certificado cargado, tocá <strong>"Probar Conexión"</strong> — no emite nada, solo confirma que el certificado, el CUIT y el punto de venta están bien enlazados (usa <code>FECompUltimoAutorizado</code>). Si tenés varias sucursales con Punto de Venta propio, elegí cuál probar en el desplegable "Sucursal a probar" (arriba de estos botones) — cada una se prueba con su propio PV. Si responde sin error, ya podés facturar de verdad con el botón "Facturar" en cada venta.
                    </Typography>

                    <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 0.5 }}>Notas</Typography>
                    <Box component="ul" sx={{ m: 0, pl: 2.5 }}>
                      <Typography component="li" variant="body2">Un certificado vence (normalmente a los 2 años) — cuando pase, se repiten los pasos 1 a 3 con un CSR nuevo.</Typography>
                      <Typography component="li" variant="body2">Homologación y Producción son bases separadas en AFIP — no comparten certificados, numeración ni comprobantes.</Typography>
                      <Typography component="li" variant="body2">Guardá <code>privada.key</code> de Producción con cuidado — quien la tenga puede facturar en tu nombre. No se manda a AFIP ni se comparte con nadie; en Agilia queda guardada igual que hoy se guarda el certificado de la impresora fiscal.</Typography>
                    </Box>
                  </AccordionDetails>
                </Accordion>
              </Grid>

              <Grid item xs={12}>
                <Card>
                  <CardContent>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2, flexWrap: 'wrap', gap: 1 }}>
                      <Typography variant="h6">
                        Certificado AFIP
                      </Typography>
                      <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                        <Button
                          variant="outlined"
                          color="success"
                          size="small"
                          startIcon={<CloudUpload />}
                          onClick={() => { setCertForm({ cert: '', cert_key: '' }); setCertDialogOpen(true); }}
                        >
                          {config.tiene_certificado ? 'Reemplazar certificado' : 'Cargar certificado'}
                        </Button>
                        <Button
                          variant="outlined"
                          color="secondary"
                          size="small"
                          startIcon={obteniendoProxNum ? <Sync className="spin" /> : <Receipt />}
                          onClick={obtenerProximoNumero}
                          disabled={obteniendoProxNum || !config.tiene_certificado}
                        >
                          {obteniendoProxNum ? 'Obteniendo...' : 'Próximo Número'}
                        </Button>
                        <Button
                          variant="outlined"
                          color="primary"
                          size="small"
                          startIcon={probando ? <Sync className="spin" /> : <PlayArrow />}
                          onClick={probarConexion}
                          disabled={probando || !config.tiene_certificado}
                        >
                          {probando ? 'Probando...' : 'Probar Conexión'}
                        </Button>
                      </Box>
                    </Box>
                    {sucursales.length > 0 && (
                      <FormControl size="small" sx={{ minWidth: 280, mb: 2 }}>
                        <InputLabel id="sucursal-prueba-label">Sucursal a probar</InputLabel>
                        <Select
                          labelId="sucursal-prueba-label"
                          label="Sucursal a probar"
                          value={sucursalPrueba}
                          onChange={(e) => setSucursalPrueba(e.target.value)}
                        >
                          <MenuItem value=""><em>General (config) — PV {config.punto_venta || '—'}</em></MenuItem>
                          {sucursales.filter((s) => Number(s.activo) === 1).map((s) => (
                            <MenuItem key={s.id} value={s.id}>
                              {s.nombre} {s.punto_venta ? `— PV ${s.punto_venta}` : '— sin PV propio (usa general)'}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    )}
                    <Alert severity={config.tiene_certificado ? 'success' : 'info'} sx={{ mb: 1 }}>
                      {config.tiene_certificado
                        ? 'Certificado AFIP cargado. La conexión es directa contra AFIP, sin intermediarios.'
                        : 'Todavía no cargaste un certificado propio de AFIP.'}
                    </Alert>
                    <Typography variant="caption" color="text.secondary">
                      El certificado se genera desde el portal de AFIP (no acá) — ver los pasos en <code>facturacion/HABILITAR_AFIP.md</code> del proyecto.
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>

              <Grid item xs={12} md={6}>
                <Card>
                  <CardContent>
                    <Typography variant="h6" gutterBottom>
                      Datos del Emisor
                    </Typography>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <TextField
                          label="Razón Social"
                          fullWidth size="small"
                          value={config.razon_social}
                          onChange={(e) => handleChange('razon_social', e.target.value)}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          label="CUIT (sin guiones)"
                          fullWidth size="small"
                          value={config.cuit}
                          onChange={(e) => handleChange('cuit', e.target.value)}
                          placeholder="20123456789"
                          inputProps={{ maxLength: 11 }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          label="Punto de Venta general (por defecto)"
                          type="number"
                          fullWidth size="small"
                          value={config.punto_venta}
                          onChange={(e) => handleChange('punto_venta', parseInt(e.target.value) || 1)}
                          helperText="Si tenés varias sucursales, cada una puede tener el suyo propio en Sucursales > Editar — este es el que se usa cuando una sucursal no tiene uno cargado."
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          label="Domicilio Comercial"
                          fullWidth size="small"
                          value={config.domicilio}
                          onChange={(e) => handleChange('domicilio', e.target.value)}
                          placeholder="Av. Corrientes 1234, CABA"
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <FormControl fullWidth size="small">
                          <InputLabel>Condición ante IVA</InputLabel>
                          <Select
                            value={config.condicion_iva}
                            label="Condición ante IVA"
                            onChange={(e) => handleChange('condicion_iva', e.target.value)}
                          >
                            {CONDICIONES_IVA.map((cond) => (
                              <MenuItem key={cond.id} value={cond.id}>{cond.nombre}</MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>

              <Grid item xs={12} md={6}>
                <Card>
                  <CardContent>
                    <Typography variant="h6" gutterBottom>
                      Configuración de Comprobantes
                    </Typography>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <FormControl fullWidth size="small">
                          <InputLabel>Tipo de Comprobante Predeterminado</InputLabel>
                          <Select
                            value={config.tipo_comprobante_predeterminado}
                            label="Tipo de Comprobante Predeterminado"
                            onChange={(e) => handleChange('tipo_comprobante_predeterminado', e.target.value)}
                          >
                            {TIPOS_COMPROBANTE.map((tipo) => (
                              <MenuItem key={tipo.id} value={tipo.id}>{tipo.nombre}</MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12}>
                        <FormControl fullWidth size="small">
                          <InputLabel>Condición IVA por defecto (cliente)</InputLabel>
                          <Select
                            value={config.condiciones_iva_por_defecto}
                            label="Condición IVA por defecto (cliente)"
                            onChange={(e) => handleChange('condiciones_iva_por_defecto', e.target.value)}
                          >
                            {CONDICIONES_IVA.map((cond) => (
                              <MenuItem key={cond.id} value={cond.id}>{cond.nombre}</MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12}>
                        <Divider sx={{ my: 1 }} />
                        <FormControlLabel
                          control={
                            <Switch
                              checked={config.mostrar_preview}
                              onChange={(e) => handleChange('mostrar_preview', e.target.checked)}
                            />
                          }
                          label="Mostrar preview antes de facturar"
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <FormControlLabel
                          control={
                            <Switch
                              checked={config.auto_imprimir}
                              onChange={(e) => handleChange('auto_imprimir', e.target.checked)}
                            />
                          }
                          label="Auto-imprimir comprobante después de facturar"
                        />
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>

                <Card sx={{ mt: 2 }}>
                  <CardContent>
                    <Typography variant="h6" gutterBottom>
                      Tipos de Comprobantes Disponibles
                    </Typography>
                    <TableContainer>
                      <Table size="small">
                        <TableHead>
                          <TableRow>
                            <TableCell><strong>Código</strong></TableCell>
                            <TableCell><strong>Tipo</strong></TableCell>
                            <TableCell><strong>Uso</strong></TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          <TableRow>
                            <TableCell>1, 2, 3</TableCell>
                            <TableCell>A</TableCell>
                            <TableCell>Para responsables inscriptos (requiere CUIT cliente)</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>6, 7, 8</TableCell>
                            <TableCell>B</TableCell>
                            <TableCell>Para consumidores finales / monotributistas</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>11, 12, 13</TableCell>
                            <TableCell>C</TableCell>
                            <TableCell>Para monotributistas (sin IVA)</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>15</TableCell>
                            <TableCell>E</TableCell>
                            <TableCell>Para exportaciones</TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </TabPanel>

          {/* ===== TAB CORREO ===== */}
          <TabPanel value={tabValue} index={1}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Card>
                  <CardContent>
                    <Typography variant="h6" gutterBottom>
                      Configuración SMTP
                    </Typography>
                    <Alert severity="info" sx={{ mb: 2 }}>
                      Estas credenciales son una sola para todo el sistema y hoy se usan para dos mails distintos
                      (no para mandarle la factura al cliente — eso todavía no está implementado):
                      <br />• <strong>Resumen de cierre de turno</strong> → llega al mail cargado en cada sucursal (ficha de la Sucursal).
                      <br />• <strong>Aviso de comprobante de pago de licencia</strong> → llega al "Email de notificación" de la tarjeta "Pago de Licencia", en la pestaña General.
                    </Alert>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          label="Servidor SMTP"
                          fullWidth size="small"
                          value={config.smtp_host}
                          onChange={(e) => handleChange('smtp_host', e.target.value)}
                          placeholder="smtp.gmail.com"
                        />
                      </Grid>
                      <Grid item xs={6} sm={3}>
                        <TextField
                          label="Puerto"
                          type="number"
                          fullWidth size="small"
                          value={config.smtp_port}
                          onChange={(e) => handleChange('smtp_port', parseInt(e.target.value) || 587)}
                        />
                      </Grid>
                      <Grid item xs={6} sm={3}>
                        <FormControl fullWidth size="small">
                          <InputLabel>Encriptación</InputLabel>
                          <Select
                            value={config.smtp_encryption}
                            label="Encriptación"
                            onChange={(e) => handleChange('smtp_encryption', e.target.value)}
                          >
                            <MenuItem value="tls">TLS</MenuItem>
                            <MenuItem value="ssl">SSL</MenuItem>
                            <MenuItem value="">Ninguna</MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          label="Usuario SMTP"
                          fullWidth size="small"
                          value={config.smtp_user}
                          onChange={(e) => handleChange('smtp_user', e.target.value)}
                          placeholder="tu@email.com"
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          label="Contraseña SMTP"
                          type="password"
                          fullWidth size="small"
                          value={config.smtp_pass}
                          onChange={(e) => handleChange('smtp_pass', e.target.value)}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          label="Email desde"
                          fullWidth size="small"
                          value={config.smtp_from_email}
                          onChange={(e) => handleChange('smtp_from_email', e.target.value)}
                          placeholder="facturacion@tudominio.com"
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          label="Nombre desde"
                          fullWidth size="small"
                          value={config.smtp_from_name}
                          onChange={(e) => handleChange('smtp_from_name', e.target.value)}
                          placeholder="Mi Empresa"
                        />
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </TabPanel>

          {/* ===== TAB GENERAL ===== */}
          <TabPanel value={tabValue} index={2}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <Card>
                  <CardContent>
                    <Typography variant="h6" gutterBottom>
                      Parámetros del Sistema
                    </Typography>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <TextField
                          label="Nombre del Sistema"
                          fullWidth size="small"
                          value={config.nombre_sistema}
                          onChange={(e) => handleChange('nombre_sistema', e.target.value)}
                          placeholder="Sistema de Gestión"
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          label="Versión"
                          fullWidth size="small"
                          value={config.version_manual || ''}
                          onChange={(e) => handleChange('version_manual', e.target.value)}
                          placeholder="ej. v1.4 - punto de venta por sucursal"
                          helperText="Etiqueta libre tuya, para tu referencia — se ve en el Dashboard junto con las fechas de deploy."
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          label="Porcentaje IVA"
                          type="number"
                          fullWidth size="small"
                          value={config.iva_porcentaje}
                          onChange={(e) => handleChange('iva_porcentaje', parseFloat(e.target.value) || 0)}
                          inputProps={{ step: 0.01 }}
                          InputProps={{ endAdornment: <Typography sx={{ mr: 1 }}>%</Typography> }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          label="Tiempo de Sesión"
                          type="number"
                          fullWidth size="small"
                          value={config.sesion_minutos}
                          onChange={(e) => handleChange('sesion_minutos', parseInt(e.target.value) || 30)}
                          InputProps={{ endAdornment: <Typography sx={{ mr: 1 }}>min</Typography> }}
                        />
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>

              <Grid item xs={12} md={6}>
                <Card>
                  <CardContent>
                    <Typography variant="h6" gutterBottom>
                      Apariencia
                    </Typography>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <TextField
                          label="Color Primario del Sistema"
                          fullWidth size="small"
                          value={config.color_primario}
                          onChange={(e) => handleChange('color_primario', e.target.value)}
                          placeholder="#071c44"
                          InputProps={{
                            startAdornment: (
                              <Box
                                sx={{
                                  width: 24, height: 24, borderRadius: '4px',
                                  bgcolor: config.color_primario || '#071c44',
                                  border: '1px solid rgba(0,0,0,0.12)',
                                  mr: 1, flexShrink: 0
                                }}
                              />
                            ),
                          }}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <Typography variant="body2" color="text.secondary">
                            Elegir color:
                          </Typography>
                          <input
                            type="color"
                            value={config.color_primario || '#071c44'}
                            onChange={(e) => handleChange('color_primario', e.target.value)}
                            style={{ width: 40, height: 40, border: 'none', cursor: 'pointer', padding: 0 }}
                          />
                        </Box>
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          label="Color de Iconos"
                          fullWidth size="small"
                          value={config.color_icono}
                          onChange={(e) => handleChange('color_icono', e.target.value)}
                          placeholder="#a9b9a6"
                          InputProps={{
                            startAdornment: (
                              <Box
                                sx={{
                                  width: 24, height: 24, borderRadius: '4px',
                                  bgcolor: config.color_icono || '#a9b9a6',
                                  border: '1px solid rgba(0,0,0,0.12)',
                                  mr: 1, flexShrink: 0
                                }}
                              />
                            ),
                          }}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <Typography variant="body2" color="text.secondary">
                            Elegir color de iconos:
                          </Typography>
                          <input
                            type="color"
                            value={config.color_icono || '#a9b9a6'}
                            onChange={(e) => handleChange('color_icono', e.target.value)}
                            style={{ width: 40, height: 40, border: 'none', cursor: 'pointer', padding: 0 }}
                          />
                        </Box>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>

              <Grid item xs={12} md={6}>
                <Card>
                  <CardContent>
                    <Typography variant="h6" gutterBottom>
                      Imágenes de Productos
                    </Typography>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          label="Máx. imágenes por producto"
                          type="number"
                          fullWidth size="small"
                          value={config.max_imagenes_producto}
                          onChange={(e) => handleChange('max_imagenes_producto', parseInt(e.target.value) || 1)}
                          inputProps={{ min: 1 }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          label="Máx. imágenes totales"
                          type="number"
                          fullWidth size="small"
                          value={config.max_imagenes_total}
                          onChange={(e) => handleChange('max_imagenes_total', parseInt(e.target.value) || 1)}
                          inputProps={{ min: 1 }}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <Box sx={{ p: 1.5, bgcolor: 'grey.100', borderRadius: 1 }}>
                          <Typography variant="body2" color="text.secondary">
                            Uso actual: <strong>{stats.total_imagenes}</strong> imágenes de <strong>{config.max_imagenes_total}</strong> totales
                          </Typography>
                        </Box>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>

              <Grid item xs={12} md={6}>
                <Card>
                  <CardContent>
                    <Typography variant="h6" gutterBottom>
                      Licencia
                    </Typography>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <TextField
                          label="Fecha de vencimiento"
                          type="date"
                          fullWidth size="small"
                          value={config.fecha_vencimiento || ''}
                          onChange={(e) => handleChange('fecha_vencimiento', e.target.value)}
                          InputLabelProps={{ shrink: true }}
                          helperText="Fecha límite de uso del sistema. Vacío = sin vencimiento."
                        />
                      </Grid>
                      {config.fecha_vencimiento && (
                        <Grid item xs={12}>
                          <Box sx={{ p: 1.5, borderRadius: 1, bgcolor: licencia.expirado ? '#fdecea' : '#e8f5e9' }}>
                            <Typography variant="body2" fontWeight={600} color={licencia.expirado ? 'error' : 'success.main'}>
                              {licencia.expirado
                                ? '⚠ Licencia vencida'
                                : licencia.dias_restantes !== null && licencia.dias_restantes <= 7
                                  ? `⚠ Vence en ${licencia.dias_restantes} día${licencia.dias_restantes === 1 ? '' : 's'}`
                                  : `✔ Vence en ${licencia.dias_restantes} días`
                              }
                            </Typography>
                            <Typography variant="caption" color="text.secondary">
                              Hasta: {new Date(config.fecha_vencimiento + 'T12:00:00').toLocaleDateString('es-AR')}
                            </Typography>
                          </Box>
                        </Grid>
                      )}
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>

              <Grid item xs={12} md={6}>
                <Card>
                  <CardContent>
                    <Typography variant="h6" gutterBottom>
                      Pago de Licencia
                    </Typography>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <FormControl fullWidth size="small">
                          <InputLabel id="producto-referencia-label">Producto de referencia (indexa el precio)</InputLabel>
                          <Select
                            labelId="producto-referencia-label"
                            label="Producto de referencia (indexa el precio)"
                            value={config.producto_referencia_club_grido || ''}
                            onChange={(e) => handleChange('producto_referencia_club_grido', e.target.value || null)}
                          >
                            <MenuItem value=""><em>Ninguno — usar el precio manual de abajo</em></MenuItem>
                            {productosCatalogo.filter((p) => Number(p.activo) === 1 && p.id_club_grido).map((p) => (
                              <MenuItem key={p.id_club_grido} value={p.id_club_grido}>
                                {p.art_descripcion} — ${Number(p.art_precio_normal || 0).toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>
                      {config.producto_referencia_club_grido && (
                        <Grid item xs={12}>
                          <TextField
                            label="Multiplicador sobre el precio del producto"
                            type="number"
                            fullWidth size="small"
                            value={config.producto_referencia_multiplicador ?? 2}
                            onChange={(e) => handleChange('producto_referencia_multiplicador', e.target.value === '' ? null : parseFloat(e.target.value))}
                            inputProps={{ step: 0.01, min: 0 }}
                            InputProps={{ startAdornment: <Typography sx={{ mr: 0.5 }}>×</Typography> }}
                            helperText={
                              `Precio por sucursal = precio del producto × este número (vacío = ×2, el default). `
                              + (config.producto_referencia_precio_base != null
                                ? `Hoy: $${Number(config.producto_referencia_precio_base).toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} × ${config.producto_referencia_multiplicador_efectivo ?? 2} = $${Number(config.monto_por_sucursal || 0).toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} por sucursal.`
                                : '')
                            }
                          />
                        </Grid>
                      )}
                      {config.fuente_precio_licencia === 'manual_fallback' && (
                        <Grid item xs={12}>
                          <Alert severity="warning">
                            El producto elegido como referencia ya no existe o está inactivo — se está usando el precio manual de abajo como respaldo. Elegí otro producto o quitá la selección.
                          </Alert>
                        </Grid>
                      )}
                      <Grid item xs={12}>
                        <TextField
                          label="Precio por sucursal (mensual)"
                          type="number"
                          fullWidth size="small"
                          value={config.pago_mensual_monto}
                          onChange={(e) => handleChange('pago_mensual_monto', parseFloat(e.target.value) || 0)}
                          inputProps={{ step: 0.01 }}
                          InputProps={{ startAdornment: <Typography sx={{ mr: 0.5 }}>$</Typography> }}
                          helperText={config.producto_referencia_club_grido
                            ? 'Hay un producto de referencia elegido arriba: precio del producto × multiplicador es lo que realmente se usa. Este número queda como respaldo si el producto se desactiva (sin multiplicador).'
                            : 'El formulario de pago del Dashboard multiplica esto por la cantidad de sucursales activas — no es el total, es por sucursal.'}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          label="Email de notificación"
                          type="email"
                          fullWidth size="small"
                          value={config.email_notificacion_pagos}
                          onChange={(e) => handleChange('email_notificacion_pagos', e.target.value)}
                          placeholder="admin@tudominio.com"
                          helperText="A este email llega el aviso cuando alguien informa un pago (usa el SMTP configurado en la pestaña Correo)"
                        />
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>

              <Grid item xs={12}>
                <Card>
                  <CardContent>
                    <HistorialPagos />
                  </CardContent>
                </Card>
              </Grid>

              <Grid item xs={12}>
                <Card sx={{ bgcolor: 'grey.50' }}>
                  <CardContent>
                    <Typography variant="body2" color="text.secondary">
                      <strong>Nota:</strong> Estos valores se usan como configuración global del sistema.
                      El porcentaje de IVA se aplica en los comprobantes electrónicos.
                      El tiempo de sesión define cada cuánto se cierra la sesión por inactividad.
                       El color primario se usa en la interfaz del sistema. El color de iconos se usa en los íconos del menú.
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </TabPanel>

          {/* ===== TAB COMANDERA ===== */}
          <TabPanel value={tabValue} index={3}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Accordion sx={{ bgcolor: 'grey.50' }}>
                  <AccordionSummary expandIcon={<ExpandMore />}>
                    <Typography variant="h6">Pasos para dejar la comandera funcionando</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Box component="ol" sx={{ m: 0, pl: 2.5 }}>
                      <Typography component="li" variant="body2" sx={{ mb: 0.5 }}>
                        Instalar <strong>QZ Tray</strong> (gratis) en cada PC de caja que vaya a imprimir — se descarga una sola vez por PC desde <a href="https://qz.io" target="_blank" rel="noopener noreferrer">qz.io</a>.
                      </Typography>
                      <Typography component="li" variant="body2" sx={{ mb: 0.5 }}>
                        Más abajo, en la sección <strong>"Certificado de firma (QZ Tray)"</strong>, tocar <strong>"Generar certificado"</strong> (una sola vez para todo el sistema).
                      </Typography>
                      <Typography component="li" variant="body2" sx={{ mb: 0.5 }}>
                        Tocar <strong>"Descargar certificado (override.crt)"</strong> (más abajo, en "Certificado de firma") y mover ese archivo descargado, tal cual, a la carpeta <code>C:\Program Files\QZ Tray\</code> de esa PC — puede pedir permisos de administrador para copiarlo ahí. Si preferís hacerlo a mano, también podés usar "Copiar certificado" y pegarlo en el Bloc de notas guardando con el nombre <strong>exacto</strong> <code>override.crt</code> (en "Guardar como", elegir tipo "Todos los archivos" para que no le agregue <code>.txt</code>). Después reiniciar QZ Tray (click derecho en su ícono de la bandeja → Exit, y volver a abrirlo). Repetir esto en cada PC de caja. Así no vuelve a preguntar permiso en cada impresión.
                      </Typography>
                      <Typography component="li" variant="body2" sx={{ mb: 0.5 }}>
                        Para cada sucursal: activar el switch, elegir la marca (Epson TM / Hasar), tocar <strong>"Buscar impresoras"</strong> (con QZ Tray corriendo en esa PC) y elegir la impresora de la lista, elegir ancho de papel y guardar.
                      </Typography>
                      <Typography component="li" variant="body2">
                        Probar con un registro real: si QZ Tray está corriendo y la impresora conectada, la comanda sale sola al guardar el registro. Si en esa primera impresión aparece un cartel de QZ Tray pidiendo permiso, tocar <strong>"Allow"</strong> (y marcar "recordar esta decisión" si aparece esa opción) — no debería volver a preguntar después de eso.
                      </Typography>
                    </Box>
                  </AccordionDetails>
                </Accordion>
              </Grid>

              <Grid item xs={12}>
                <Accordion defaultExpanded>
                  <AccordionSummary expandIcon={<ExpandMore />}>
                    <Typography variant="h6">Certificado de firma (QZ Tray)</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    {config.impresion_qz_cert ? (
                      <>
                        <TextField
                          label="Certificado público" multiline minRows={4} fullWidth size="small"
                          value={config.impresion_qz_cert}
                          InputProps={{ readOnly: true }}
                          sx={{ mb: 1 }}
                        />
                        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                          <Button
                            size="small" startIcon={<Download />}
                            onClick={descargarCertificadoImpresion}
                          >
                            Descargar certificado (override.crt)
                          </Button>
                          <Button
                            size="small" startIcon={<ContentCopy />}
                            onClick={() => {
                              navigator.clipboard.writeText(config.impresion_qz_cert);
                              avisar('Certificado copiado al portapapeles', 'info');
                            }}
                          >
                            Copiar certificado
                          </Button>
                        </Box>
                      </>
                    ) : (
                      <Alert severity="warning" sx={{ mb: 2 }}>Todavía no generaste el certificado de firma.</Alert>
                    )}
                    <Box sx={{ mt: 2 }}>
                      <Button
                        variant="outlined"
                        startIcon={generandoCertImpresion ? <Sync className="spin" /> : <CloudUpload />}
                        onClick={generarCertificadoImpresion}
                        disabled={generandoCertImpresion}
                      >
                        {generandoCertImpresion ? 'Generando...' : (config.impresion_qz_cert ? 'Regenerar certificado' : 'Generar certificado')}
                      </Button>
                    </Box>
                  </AccordionDetails>
                </Accordion>
              </Grid>

              <Grid item xs={12}>
                <Card>
                  <CardContent>
                    <Typography variant="h6" gutterBottom>
                      Impresora por sucursal
                    </Typography>
                    {cargandoSucursales ? (
                      <Cargando inline />
                    ) : isMobile ? (
                      <Stack spacing={1.5}>
                        {sucursalesImpresion.length === 0 && (
                          <Typography variant="body2" color="text.secondary">No hay sucursales activas.</Typography>
                        )}
                        {sucursalesImpresion.map((s, idx) => {
                          const opcionesImpresoras = impresorasPorSucursal[s.id]
                            ?? (s.impresion_nombre_impresora ? [s.impresion_nombre_impresora] : []);
                          return (
                            <Paper key={s.id} variant="outlined" sx={{ p: 1.5 }}>
                              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1.5 }}>
                                <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>{s.nombre}</Typography>
                                <FormControlLabel
                                  sx={{ m: 0 }}
                                  control={
                                    <Switch
                                      size="small"
                                      checked={!!Number(s.impresion_habilitada)}
                                      onChange={(e) => actualizarSucursalImpresion(idx, 'impresion_habilitada', e.target.checked ? 1 : 0)}
                                    />
                                  }
                                  label="Habilitada"
                                  labelPlacement="start"
                                />
                              </Box>
                              <Stack spacing={1.5}>
                                <FormControl size="small" fullWidth>
                                  <InputLabel>Marca</InputLabel>
                                  <Select
                                    label="Marca"
                                    value={s.impresion_marca || 'epson'}
                                    onChange={(e) => actualizarSucursalImpresion(idx, 'impresion_marca', e.target.value)}
                                  >
                                    <MenuItem value="epson">Epson TM</MenuItem>
                                    <MenuItem value="hasar">Hasar</MenuItem>
                                  </Select>
                                </FormControl>
                                <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center' }}>
                                  <FormControl size="small" fullWidth>
                                    <InputLabel>Impresora</InputLabel>
                                    <Select
                                      label="Impresora"
                                      displayEmpty
                                      value={s.impresion_nombre_impresora || ''}
                                      onChange={(e) => actualizarSucursalImpresion(idx, 'impresion_nombre_impresora', e.target.value)}
                                    >
                                      <MenuItem value=""><em>Sin elegir</em></MenuItem>
                                      {opcionesImpresoras.map((nombre) => (
                                        <MenuItem key={nombre} value={nombre}>{nombre}</MenuItem>
                                      ))}
                                    </Select>
                                  </FormControl>
                                  <IconButton
                                    size="small"
                                    onClick={() => buscarImpresorasPara(s.id)}
                                    title="Buscar impresoras (QZ Tray debe estar corriendo en esta PC)"
                                  >
                                    {buscandoId === s.id ? <CircularProgress size={16} /> : <Sync fontSize="small" />}
                                  </IconButton>
                                </Box>
                                <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                                  <FormControl size="small" sx={{ flex: 1 }}>
                                    <InputLabel>Ancho</InputLabel>
                                    <Select
                                      label="Ancho"
                                      value={Number(s.impresion_ancho_papel) || 80}
                                      onChange={(e) => actualizarSucursalImpresion(idx, 'impresion_ancho_papel', Number(e.target.value))}
                                    >
                                      <MenuItem value={58}>58mm</MenuItem>
                                      <MenuItem value={80}>80mm</MenuItem>
                                    </Select>
                                  </FormControl>
                                  <FormControlLabel
                                    sx={{ m: 0 }}
                                    control={
                                      <Switch
                                        size="small"
                                        checked={!!Number(s.impresion_cortar_papel)}
                                        onChange={(e) => actualizarSucursalImpresion(idx, 'impresion_cortar_papel', e.target.checked ? 1 : 0)}
                                      />
                                    }
                                    label="Corte"
                                  />
                                </Box>
                                <TextField
                                  fullWidth size="small" label="Nombre de fantasía (encabezado de la comanda)"
                                  value={s.impresion_nombre_fantasia || ''}
                                  onChange={(e) => actualizarSucursalImpresion(idx, 'impresion_nombre_fantasia', e.target.value)}
                                  placeholder="Heladería Grido"
                                />
                                <TextField
                                  fullWidth size="small" label="Pie de la comanda"
                                  value={s.impresion_texto_pie || ''}
                                  onChange={(e) => actualizarSucursalImpresion(idx, 'impresion_texto_pie', e.target.value)}
                                  placeholder="¡Gracias por su compra!"
                                />
                                <Box sx={{ display: 'flex', gap: 1 }}>
                                  <Button
                                    fullWidth size="small" variant="outlined"
                                    onClick={() => setPreviewSucursal(s)}
                                  >
                                    Vista previa
                                  </Button>
                                  <Button
                                    fullWidth size="small" variant="contained"
                                    onClick={() => guardarSucursalImpresion(s)}
                                    disabled={guardandoId === s.id}
                                  >
                                    {guardandoId === s.id ? <CircularProgress size={14} color="inherit" /> : 'Guardar'}
                                  </Button>
                                </Box>
                              </Stack>
                            </Paper>
                          );
                        })}
                      </Stack>
                    ) : (
                      <TableContainer sx={{ overflowX: 'auto' }}>
                        <Table size="small" sx={{ minWidth: 900 }}>
                          <TableHead>
                            <TableRow>
                              <TableCell>Sucursal</TableCell>
                              <TableCell align="center">Habilitada</TableCell>
                              <TableCell>Marca</TableCell>
                              <TableCell>Impresora</TableCell>
                              <TableCell>Ancho</TableCell>
                              <TableCell align="center">Corte</TableCell>
                              <TableCell>Nombre de fantasía</TableCell>
                              <TableCell>Pie de la comanda</TableCell>
                              <TableCell></TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {sucursalesImpresion.map((s, idx) => {
                              const opcionesImpresoras = impresorasPorSucursal[s.id]
                                ?? (s.impresion_nombre_impresora ? [s.impresion_nombre_impresora] : []);
                              return (
                                <TableRow key={s.id}>
                                  <TableCell>{s.nombre}</TableCell>
                                  <TableCell align="center">
                                    <Switch
                                      size="small"
                                      checked={!!Number(s.impresion_habilitada)}
                                      onChange={(e) => actualizarSucursalImpresion(idx, 'impresion_habilitada', e.target.checked ? 1 : 0)}
                                    />
                                  </TableCell>
                                  <TableCell>
                                    <FormControl size="small" sx={{ minWidth: 110 }}>
                                      <Select
                                        value={s.impresion_marca || 'epson'}
                                        onChange={(e) => actualizarSucursalImpresion(idx, 'impresion_marca', e.target.value)}
                                      >
                                        <MenuItem value="epson">Epson TM</MenuItem>
                                        <MenuItem value="hasar">Hasar</MenuItem>
                                      </Select>
                                    </FormControl>
                                  </TableCell>
                                  <TableCell>
                                    <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center' }}>
                                      <FormControl size="small" sx={{ minWidth: 170 }}>
                                        <Select
                                          displayEmpty
                                          value={s.impresion_nombre_impresora || ''}
                                          onChange={(e) => actualizarSucursalImpresion(idx, 'impresion_nombre_impresora', e.target.value)}
                                        >
                                          <MenuItem value=""><em>Sin elegir</em></MenuItem>
                                          {opcionesImpresoras.map((nombre) => (
                                            <MenuItem key={nombre} value={nombre}>{nombre}</MenuItem>
                                          ))}
                                        </Select>
                                      </FormControl>
                                      <IconButton
                                        size="small"
                                        onClick={() => buscarImpresorasPara(s.id)}
                                        title="Buscar impresoras (QZ Tray debe estar corriendo en esta PC)"
                                      >
                                        {buscandoId === s.id ? <CircularProgress size={16} /> : <Sync fontSize="small" />}
                                      </IconButton>
                                    </Box>
                                  </TableCell>
                                  <TableCell>
                                    <FormControl size="small" sx={{ minWidth: 90 }}>
                                      <Select
                                        value={Number(s.impresion_ancho_papel) || 80}
                                        onChange={(e) => actualizarSucursalImpresion(idx, 'impresion_ancho_papel', Number(e.target.value))}
                                      >
                                        <MenuItem value={58}>58mm</MenuItem>
                                        <MenuItem value={80}>80mm</MenuItem>
                                      </Select>
                                    </FormControl>
                                  </TableCell>
                                  <TableCell align="center">
                                    <Switch
                                      size="small"
                                      checked={!!Number(s.impresion_cortar_papel)}
                                      onChange={(e) => actualizarSucursalImpresion(idx, 'impresion_cortar_papel', e.target.checked ? 1 : 0)}
                                    />
                                  </TableCell>
                                  <TableCell>
                                    <TextField
                                      size="small" sx={{ minWidth: 150 }} placeholder="Heladería Grido"
                                      value={s.impresion_nombre_fantasia || ''}
                                      onChange={(e) => actualizarSucursalImpresion(idx, 'impresion_nombre_fantasia', e.target.value)}
                                    />
                                  </TableCell>
                                  <TableCell>
                                    <TextField
                                      size="small" sx={{ minWidth: 150 }} placeholder="¡Gracias por su compra!"
                                      value={s.impresion_texto_pie || ''}
                                      onChange={(e) => actualizarSucursalImpresion(idx, 'impresion_texto_pie', e.target.value)}
                                    />
                                  </TableCell>
                                  <TableCell>
                                    <Box sx={{ display: 'flex', gap: 0.5 }}>
                                      <Button size="small" variant="outlined" onClick={() => setPreviewSucursal(s)}>
                                        Vista previa
                                      </Button>
                                      <Button
                                        size="small" variant="contained"
                                        onClick={() => guardarSucursalImpresion(s)}
                                        disabled={guardandoId === s.id}
                                      >
                                        {guardandoId === s.id ? <CircularProgress size={14} color="inherit" /> : 'Guardar'}
                                      </Button>
                                    </Box>
                                  </TableCell>
                                </TableRow>
                              );
                            })}
                            {sucursalesImpresion.length === 0 && (
                              <TableRow>
                                <TableCell colSpan={9}>
                                  <Typography variant="body2" color="text.secondary">No hay sucursales activas.</Typography>
                                </TableCell>
                              </TableRow>
                            )}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    )}
                  </CardContent>
                </Card>
              </Grid>

            </Grid>
          </TabPanel>

          {/* BOTÓN GUARDAR */}
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3, pt: 2, borderTop: '1px solid rgba(0,0,0,0.12)' }}>
            <Button
              variant="outlined"
              onClick={fetchConfig}
              disabled={loading}
              sx={{ mr: 2 }}
            >
              Cancelar
            </Button>
            <Button
              variant="contained"
              color="primary"
              startIcon={guardando ? <CircularProgress size={20} color="inherit" /> : <Save />}
              onClick={guardarConfig}
              disabled={guardando}
            >
              {guardando ? 'Guardando...' : 'Guardar Configuración'}
            </Button>
          </Box>
        </Paper>
      </Box>

      {/* Diálogo Prueba de Conexión */}
      <Dialog open={testDialogOpen} onClose={() => setTestDialogOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {testResult?.success ? (
            <CheckCircle color="success" />
          ) : (
            <ErrorIcon color="error" />
          )}
          Prueba de Conexión ARCA
        </DialogTitle>
        <DialogContent>
          {probando ? (
            <Cargando inline mensaje="Conectando con ARCA..." />
          ) : testResult ? (
            <Box>
              <Alert severity={testResult.success ? 'success' : 'error'} sx={{ mb: 2 }}>
                {testResult.message}
              </Alert>
              {testResult.success && testResult.data && (
                <Box sx={{ bgcolor: 'grey.100', p: 2, borderRadius: 1 }}>
                  <Typography variant="body2">
                    <strong>Punto de Venta:</strong> {testResult.data.punto_venta}
                  </Typography>
                  <Typography variant="body2">
                    <strong>Último Comprobante:</strong> #{testResult.data.ultimo_numero}
                  </Typography>
                  <Typography variant="body2">
                    <strong>Ambiente:</strong> {testResult.data.ambiente === 'dev' ? 'Desarrollo' : 'Producción'}
                  </Typography>
                  <Typography variant="body2">
                    <strong>Fecha:</strong> {testResult.data.fecha}
                  </Typography>
                </Box>
              )}
            </Box>
          ) : (
            <Typography>Esperando resultado...</Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setTestDialogOpen(false)} variant="contained">Cerrar</Button>
        </DialogActions>
      </Dialog>

      {/* Diálogo Certificado */}
      <Dialog open={certDialogOpen} onClose={() => !generandoCert && setCertDialogOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Cargar certificado AFIP</DialogTitle>
        <DialogContent>
          <Alert severity="info" sx={{ mb: 2 }}>
            Pegá acá el certificado (<code>.crt</code>) y la clave privada que generaste en el portal de AFIP —
            ver los pasos en <code>facturacion/HABILITAR_AFIP.md</code>. Usá siempre el par de <strong>Homologación</strong> para
            probar antes de cargar el de Producción.
          </Alert>
          <TextField
            label="Certificado (empieza con -----BEGIN CERTIFICATE-----)"
            fullWidth multiline minRows={5} sx={{ mb: 2 }}
            value={certForm.cert}
            onChange={(e) => setCertForm({ ...certForm, cert: e.target.value })}
            disabled={generandoCert}
          />
          <TextField
            label="Clave privada (empieza con -----BEGIN PRIVATE KEY-----)"
            fullWidth multiline minRows={5}
            value={certForm.cert_key}
            onChange={(e) => setCertForm({ ...certForm, cert_key: e.target.value })}
            disabled={generandoCert}
          />
          {generandoCert && (
            <Cargando inline size={24} mensaje="Validando certificado..." />
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setCertDialogOpen(false)} disabled={generandoCert}>Cancelar</Button>
          <Button onClick={guardarCertificado} variant="contained" disabled={generandoCert || !certForm.cert || !certForm.cert_key}>
            {generandoCert ? 'Guardando...' : 'Guardar Certificado'}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={!!previewSucursal} onClose={() => setPreviewSucursal(null)} maxWidth="xs" fullWidth>
        <DialogTitle>Vista previa de la comanda — {previewSucursal?.nombre}</DialogTitle>
        <DialogContent>
          <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1.5 }}>
            Con un producto de prueba, usando el nombre de fantasía, ancho de papel y pie que tenga cargados esta sucursal ahora mismo (aunque todavía no lo hayas guardado).
          </Typography>
          {previewSucursal && (
            <Box
              component="pre"
              sx={{
                fontFamily: 'monospace', fontSize: 12, bgcolor: 'grey.100', color: 'text.primary',
                p: 2, borderRadius: 1, whiteSpace: 'pre-wrap', overflowX: 'auto', m: 0,
              }}
            >
              {construirTicketPreviewTexto(ventaDePrueba(previewSucursal.nombre), previewSucursal)}
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setPreviewSucursal(null)}>Cerrar</Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
}

export default FacturacionConfig;
